import axios from 'axios';
import parse from 'html-react-parser';
import moment from 'moment';
import React from 'react';
import toastr from 'toastr';

import { API_ERROR_REASON_REQUIRED_CONSENT } from './lib/axios/api.const';
import { ACCEPT_ATTRIBUTE } from './config/fileTypes';

export const showToast = (type, message, duration, multiple) => {
  let toastDuration = duration || 3000;

  if (typeof multiple === 'undefined') {
    toastr.remove();
  }

  toastr.options.timeOut = toastDuration;
  toastr.options.positionClass = 'toast-bottom-center custom-toast';
  toastr.options.closeButton = true;
  toastr[type](message);
};

export const removeToast = () => {
  toastr.remove();
};

export const getParameterByName = (name, url) => {
  if (!url) {
    url = window.location.href;
  }
  name = name.replace(/[\[\]]/g, '\\$&');
  const exp = ['[?&]', name, '(=([^&#]*)|&|#|$)'].join('');
  var regex = new RegExp(exp),
    results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return '';
  return decodeURIComponent(results[2].replace(/\+/g, ' '));
};

export const validateEmail = (email) => {
  const regEx =
    /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return regEx.test(email);
};

export const acceptedFileTypes = () => ACCEPT_ATTRIBUTE;

export const fileValidation = (files) => {
  let totalSize = 0;

  const checkFileSupported = (item) => {
    let file = item.file;
    let fileExtension = file.name.split('.').pop();
    let index = acceptedFileTypes()
      .split(',')
      .indexOf('.' + fileExtension.toLowerCase());

    if (index < 0) {
      item.error = true;
      showToast('error', `File type not supported`);
    }

    return item;
  };

  const handleMaxFileSize = (item, length) => {
    let max = maxFileSize();
    let fileSize = item.file.size;
    let isExceed = fileSize > max;
    totalSize += fileSize;
    let isExceedTotalSize = totalSize > max;

    if (isExceed && length === 1) {
      item.error = true;
      showToast(
        'error',
        `File size exceeds ${Math.floor(max / (1024 * 1024))} MB`
      );
    } else if (isExceedTotalSize) {
      item.error = true;
      showToast(
        'error',
        `Batch file size exceeds ${Math.floor(max / (1024 * 1024))} MB`
      );
    }

    return item;
  };

  const sorted = files.sort((a, b) => a.size - b.size);
  const list = sorted.map((f, i) => {
    let item = {
      file: f,
    };
    item = checkFileSupported(item);

    if (!item.error) {
      item = handleMaxFileSize(item, files.length);
    }

    return item;
  });

  return list.filter((f) => !f.error).map((m) => m.file);
};

export const displayDate = (strDate) => {
  return moment(strDate, 'YYYY MMM DD').format('MMMM DD, YYYY');
};

export const displayDateMD = (strDate) => {
  return moment(strDate).format('MMMM DD');
};

export const formatDate = (strDate) => {
  if (
    strDate === '' ||
    strDate === undefined ||
    strDate === '00-00-0000' ||
    strDate === '00-00-0000 00:00:00'
  ) {
    strDate = '01-01-1970';
  }

  let res = strDate.split('/');
  return res[2] + '/' + res[0] + '/' + res[1];
};

export function isNumeric(n) {
  return !isNaN(parseFloat(n)) && isFinite(n);
}

export const isNumber = (_this, params, e) => {
  var value = '',
    state = false;

  if (
    isNumeric(e.target.value) ||
    e.target.value === '' ||
    (typeof e.target.value.split('.')[1] === 'undefined' &&
      /^\d+$/.test(e.target.value)) ||
    (e.target.value.split('.')[1] === '' && e.target.value === '.')
  ) {
    state = true;
    value = e.target.value;
  }

  if (state) {
    if (params.objectName) {
      var object = _this.state[params.objectName];
      object[params.name] = value;
      _this.setState({
        [params.objectName]: object,
      });
    } else {
      _this.setState({
        [params.name]: value,
      });
    }
  }
};

export const numberFormat = (number, decimals, decPoint, thousandsSep) => {
  number = (number + '').replace(/[^0-9+\-Ee.]/g, '');
  var n = !isFinite(+number) ? 0 : +number;
  var prec = !isFinite(+decimals) ? 0 : Math.abs(decimals);
  var sep = typeof thousandsSep === 'undefined' ? ',' : thousandsSep;
  var dec = typeof decPoint === 'undefined' ? '.' : decPoint;
  var s = '';

  var toFixedFix = function (_n, _prec) {
    var k = Math.pow(10, _prec);
    return '' + (Math.round(_n * k) / k).toFixed(_prec);
  };

  s = (prec ? toFixedFix(n, prec) : '' + Math.round(n)).split('.');

  if (s[0].length > 3) {
    s[0] = s[0].replace(/\B(?=(?:\d{3})+(?!\d))/g, sep);
  }

  if ((s[1] || '').length < prec) {
    s[1] = s[1] || '';
    s[1] += new Array(prec - s[1].length + 1).join('0');
  }

  return s.join(dec);
};

export const getCookie = (cname) => {
  var name = cname + '=';
  var decodedCookie = decodeURIComponent(document.cookie);
  var ca = decodedCookie.split(';');

  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];

    while (c.charAt(0) === ' ') {
      c = c.substring(1);
    }

    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length);
    }
  }

  return '';
};

export const maxFileSize = () => {
  const maxMb = 25;
  return Math.floor(maxMb * 1024 * 1024);
};

export const setCookie = (cname, cvalue, exdays) => {
  var d = new Date();
  d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
  var expires = 'expires=' + d.toUTCString();
  document.cookie = cname + '=' + cvalue + ';' + expires + ';path=/';
};

export const checkContactNumber = (value) => {
  const regEx = /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/;
  return regEx.test(value);
};

export const exportToExcel = (fields) => {
  var form = document.createElement('form');
  document.body.appendChild(form);
  form.method = 'POST';
  form.target = '_blank';
  form.action = '/api/exportReport';

  Object.keys(fields).forEach(function (field, index) {
    var element = document.createElement('input');
    element.name = field;
    element.value = fields[field];
    element.type = 'hidden';
    form.appendChild(element);
  });

  form.submit();
};

export const CurrencyList = (cb) => {
  $.ajax({
    url: '/json/currency.json',
    dataType: 'json',
    type: 'get',
    success: function (currency) {
      var curs = Object.keys(currency).map(function (cur, index) {
        return {
          id: cur,
          name: cur,
        };
      });
      cb(curs);
    },
  });
};

export const CountryList = (cb) => {
  $.ajax({
    url: '/json/country.json',
    dataType: 'json',
    type: 'get',
    success: function (countries) {
      var country = Object.keys(countries).map(function (_country, index) {
        return {
          id: _country,
          name: countries[_country],
        };
      });
      cb(country);
    },
  });
};

export const NationalityList = (cb) => {
  $.ajax({
    url: '/json/nationality.json',
    dataType: 'json',
    type: 'get',
    success: function (nationality) {
      cb(nationality);
    },
  });
};

export const setDatePicker = (handleDate, Id) => {
  $('#' + Id).on('change', function (e) {
    handleDate(e);
  });

  try {
    $('#' + Id).pickadate({
      selectMonths: true,
      selectYears: 200,
      format: 'yyyy-mm-dd',
      onSet: function (data) {
        if (data.select !== undefined) {
          $('.picker__close').click();
        }
      },
    });
  } catch (error) {
    //console.log(error)
  }
};

export const setTimePicker = (handleDate, Id) => {
  $('#' + Id).on('change', function (e) {
    handleDate(e);
  });

  try {
    $('#' + Id).pickatime({
      twelvehour: false,
    });
  } catch (error) {
    //console.log(error)
  }
};

export const getFilePathExtension = (path) => {
  var filename = path.split('\\').pop().split('/').pop();
  return filename.substr(
    (Math.max(0, filename.lastIndexOf('.')) || Infinity) + 1
  );
};

export const postData = (url, data, cb) => {
  axios
    .post(url, data)
    .then((res) => {
      cb(res);
    })
    .catch((err) => {
      cb(err.response);
    });
};

export const postDataUpload = (url, data, config, cb) => {
  axios
    .post(url, data, config)
    .then((res) => {
      cb(res);
    })
    .catch((err) => {
      cb(err.response);
    });
};

export const getData = (url, data, cb) => {
  return axios
    .get(url, data)
    .then((res) => {
      cb(res);
    })
    .catch((err) => {
      cb(err.response);
    });
};

export const putData = (url, data, cb) => {
  axios
    .put(url, data)
    .then((res) => {
      cb(res);
    })
    .catch((err) => {
      cb(err.response);
    });
};

export const deleteData = (url, data, cb) => {
  axios
    .delete(url, data)
    .then((res) => {
      cb(res);
    })
    .catch((err) => {
      cb(err.response);
    });
};

export const deleteRequest = (url, payload, cb) => {
  axios
    .delete(url, { data: payload })
    .then((res) => {
      cb(res);
    })
    .catch((err) => {
      cb(err.response);
    });
};

export const notificationType = (notif) => {
  const type = notif.type;
  const text = notif.message;

  switch (type) {
    case 'fileNewUpload':
      return 'uploaded a new file';
    case 'taskAssigned':
      if (text.includes('reassignTask')) {
        return 'Tasks have been reassigned to you';
      }
      return 'assigned a new task for you';
    case 'taskReviewer':
      if (text.includes('reassignTask')) {
        return 'Tasks have been reassigned to you as a reviewer';
      }
      return 'assigned you as a reviewer of a task';
    case 'taskSubmittedReview':
      return 'needs your review to complete a task';
    case 'taskReviewed':
      return 'reviewed and approved task assigned to you';
    case 'taskApprover':
      if (text.includes('reassignTask')) {
        return 'Tasks have been reassigned to you as an approver';
      }
      return 'assigned you as an approver of a task';
    case 'taskSubmittedApproval':
      return 'needs your approval to complete a task';
    case 'messageSend':
      return 'sent you a new message';
    case 'messageMentioned':
      return 'mentioned you in a message';
    case 'fileTagged':
      return 'mentioned you in a file';
    case 'taskTagged':
      return 'mentioned you in a task';
    case 'commentReplies':
      return 'replied to a comment';
    case 'taskFollowingCompleted':
      return 'completed a task';
    case 'taskMemberCompleted':
      return 'completed a task';
    case 'taskDeadline':
      return 'You seem to have missed a deadline';
    case 'taskFollowingDeadline':
      return 'Task following seems to have missed a deadline';
    case 'taskTeamDeadline':
      return 'Team member seems to have missed a deadline';
    case 'taskResponsibleDeadLine':
      return 'Task seems to have missed a deadline as a responsible';
    case 'taskResponsibleBeforeDeadline':
      return 'Task about to be due';
    case 'taskApproved':
      return 'approved a task';
    case 'taskBeforeDeadline':
      return 'Task about to be due';
    case 'taskAssignedComment':
      return "commented on a task that's assigned to you";
    case 'taskFollower':
      return `${text}`;
    case 'taskReviewerChangeRequest':
    case 'taskApproverChangeRequest':
      return 'has a change request on a task that assigned to you';
    case 'fileCommented':
      return 'commented on your file';
    case 'fileReplies':
      return 'replied to your comment on a file';
    default:
      return type;
  }
};

export const parseQuery = (queryString) => {
  var query = {};
  var pairs = (
    queryString[0] === '?' ? queryString.substr(1) : queryString
  ).split('&');

  for (var i = 0; i < pairs.length; i++) {
    var pair = pairs[i].split('=');
    query[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1] || '');
  }

  return query;
};

export const workstreamActiveTab = (tab) => {
  var tabIndex = 0;

  if (tab === 'document') {
    tabIndex = 1;
  }

  return tabIndex;
};

export const textColor = (hexcolor) => {
  if (hexcolor) {
    var r = parseInt(hexcolor.substr(0, 2), 16);
    var g = parseInt(hexcolor.substr(2, 2), 16);
    var b = parseInt(hexcolor.substr(4, 2), 16);
    var yiq = (r * 299 + g * 587 + b * 114) / 1000;
    return yiq >= 128 ? 'black' : 'white';
  }
};

export const parseToHtml = (text) => {
  return parse(text.replace(/\r?\n/g, '<br />'));
};

export const Loading = (props) => {
  return <div className="fa-spinner spin" role="status"></div>;
};

export const exportToCsv = (filename, rows) => {
  const processRow = (row) => {
    let finalVal = '';

    for (let j = 0; j < row.length; j++) {
      let innerValue = row[j] === null ? '' : row[j].toString();

      if (row[j] instanceof Date) {
        innerValue = row[j].toLocaleString();
      }

      let result = innerValue.replace(/"/g, '""');

      if (result.search(/("|,|\n)/g) >= 0) {
        result = '"' + result + '"';
      }

      if (j > 0) {
        finalVal += ',';
      }

      finalVal += result;
    }

    return finalVal + '\n';
  };

  let csvFile = '';

  for (let i = 0; i < rows.length; i++) {
    csvFile += processRow(rows[i]);
  }

  let url = '';
  const blob = new Blob([csvFile], {
    type: 'text/csv;charset=utf-8;',
  });

  if (navigator.msSaveOrOpenBlob) {
    url = navigator.msSaveOrOpenBlob(blob, filename);
  } else {
    url = URL.createObjectURL(blob);
    var link = document.createElement('a');

    if (link.download !== undefined) {
      // feature detection
      // Browsers that support HTML5 download attribute
      url = URL.createObjectURL(blob);
      link.setAttribute('href', url);
      link.setAttribute('download', filename);
      link.style.visibility = 'hidden';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  }
};

export const timeToMins = (time) => {
  var b = time.split(':');
  return b[0] * 60 + +b[1];
};

export const timeFromMins = (mins) => {
  function z(n) {
    return (n < 10 ? '0' : '') + n;
  }

  var h = (mins / 60) | 0;
  var m = mins % 60;
  return z(h) + ':' + z(m) + ':' + '00';
};

export const addTimes = (t0, t1) => {
  return timeFromMins(timeToMins(t0) + timeToMins(t1));
};

export const subtractTimes = (t0, t1) => {
  return timeFromMins(timeToMins(t0) - timeToMins(t1));
};

export const redirectToLegalConsentPage = () => {
  // Already on the consent page: do NOT reload. While consents are pending, every
  // background API call makes the server emit MISSING_REQUIRED_CONSENTS, and a
  // full reload on each one traps the user in an endless refresh before they can
  // ever click Accept. Landing here once (below) is enough; after that, stay put.
  if (window.location.hash.includes('/request-legal-consent')) {
    return;
  }
  window.location.hash = '/request-legal-consent';
  window.location.reload();
  return;
};

// Full-screen branded loader (same blinking CloudCFO logo as the static boot
// loader in views/index.ejs). Self-contained — injects its own styles — so it
// can be shown at runtime for transitions that would otherwise be a frozen or
// white screen (e.g. logout, while the session is destroyed and the page
// redirects). Reuses the #app-boot-loader id so it's visually identical.
export const showAppLoader = () => {
  if (
    typeof document === 'undefined' ||
    document.getElementById('app-boot-loader')
  ) {
    return;
  }
  if (!document.getElementById('app-boot-loader-style')) {
    const style = document.createElement('style');
    style.id = 'app-boot-loader-style';
    style.textContent =
      '@keyframes app-boot-blink{0%,100%{opacity:1}50%{opacity:.25}}' +
      '#app-boot-loader{position:fixed;inset:0;display:flex;align-items:center;justify-content:center;background:#fff;z-index:2147483647}' +
      '#app-boot-loader img{width:140px;height:auto;animation:app-boot-blink 1.2s ease-in-out infinite}';
    document.head.appendChild(style);
  }
  const el = document.createElement('div');
  el.id = 'app-boot-loader';
  el.setAttribute('role', 'status');
  el.setAttribute('aria-label', 'Loading');
  el.innerHTML =
    '<img src="/images/cloudcfo-logo-colored-icon-above-text.png" alt="CloudCFO" />';
  document.body.appendChild(el);
};

export const hideAppLoader = () => {
  if (typeof document === 'undefined') return;
  const el = document.getElementById('app-boot-loader');
  if (el) el.remove();
};

export default {
  getParameterByName,
  validateEmail,
  fileValidation,
  displayDate,
  displayDateMD,
  formatDate,
  isNumeric,
  isNumber,
  numberFormat,
  getCookie,
  maxFileSize,
  setCookie,
  checkContactNumber,
  exportToExcel,
  CurrencyList,
  CountryList,
  NationalityList,
  setDatePicker,
  setTimePicker,
  getFilePathExtension,
  postData,
  postDataUpload,
  getData,
  putData,
  deleteData,
  deleteRequest,
  notificationType,
  parseQuery,
  workstreamActiveTab,
  textColor,
  parseToHtml,
  Loading,
  exportToCsv,
  timeToMins,
  timeFromMins,
  addTimes,
  subtractTimes,
  redirectToLegalConsentPage,
};
